import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ReportService {
  private baseApiUrl: string;

  constructor(private configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = this.configurationService.BaseApiUrl;
  }

  getUserReport(data: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'report/userReport', data).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
  

   getInfoByNationalId(nationalId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `interface/get-info/${nationalId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  // reports(
  //   transactionData: any,
  //   type: number,
  //   fromDate: Date,
  //   toDate: Date,
  //   reportFormateType: number,
  //   scrollType: number,
  //   createdBy: number,
  //   generalLedgerId: number,
  //   scheduleType: number,
  //   month: number,
  //   year:number,
  //   module:string,
  //   customerIdentifier:string,
  //   accountStatus:number,
  //   status:number,
  //   accountNo:number,
  //   schemeId:number,
  //   accrualFrequency:number,
  //   customerName:number,
  //   noOfStartDays: number,
  //   noOfEndDays: number,

  // ): Observable<any> {
  //   return this.httpClient
  //     .post(this.baseApiUrl + "reports", {
  //       transactionDate: transactionData,
  //       type: type,
  //       fromDate: fromDate,
  //       toDate: toDate,
  //       reportFormateType: reportFormateType,
  //       scrollType: scrollType,
  //       scheduleType: scheduleType,
  //       generalLedgerId: generalLedgerId,
  //       createdBy: createdBy,
  //       month: month,
  //       year: year,
  //       accountStatus: accountStatus,
  //       status: status,
  //       schemeId: schemeId,
  //       accrualFrequency: accrualFrequency,
  //       noOfStartDays: noOfStartDays,
  //       noOfEndDays: noOfEndDays,
  //       customerName: customerName,
  //       accountNo: accountNo,
  //       currentDate: new Date(),
  //       module:module,
  //       customerIdentifier:customerIdentifier
  //     })
  //     .pipe(
  //       map((res: Response) => res),
  //       catchError((err: any) =>
  //         observableThrowError(err.message || "Server error")
  //       )
  //     );
  // }
  reports(requestParams: Partial<{
       transactionData: any,
       branchId: number,
    type: number,
    fromDate: Date,
    toDate: Date,
    reportFormateType: number,
    scrollType: number,
    createdBy: number,
    generalLedgerId: number,
    scheduleType: number,
    month: number,
    year:number,
    module:string,
    customerIdentifier:string,
    accountStatus:number,
    status:number,
    accountNumber: string,
    schemeId:number,
    accrualFrequency:number,
    customerName:number,
    noOfStartDays: number,
    noOfEndDays: number,
    nationalId?: string,
    AccountNo:number
  }>):
  Observable<any> {
    return this.httpClient
      .post(this.baseApiUrl + "reports", {
        ...requestParams, // Pass only the provided parameters
        currentDate: new Date() // Include current date if needed
      })
      .pipe(
        map((res: Response) => res),
        catchError((err: any) =>
          observableThrowError(err.message || "Server error")
        )
      );
}

  getUserReportPdf(filter: string, pageIndex: number, pageSize: number, sortColumn: string, sortAscending: boolean): void {
    let params = new HttpParams();
    params = params.append('filter', filter);
    params = params.append('pageIndex', pageIndex.toString());
    params = params.append('pageSize', pageSize.toString());
    params = params.append('sortColumn', sortColumn);
    params = params.append('sortAscending', sortAscending.toString());
    this.httpClient.get(this.baseApiUrl + 'report/userReport', { params: params }).pipe(
      map((res: Response) => {
        return res;
      }),
      catchError((err: any) => {
        console.log('Failed to get user report pdf', err);
        alert('Failed to get user report pdf');
        return observableThrowError(err.message || 'Server error');
      })
    );
  }

  getXDSinfoByNationalId(nationalId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `interface/${nationalId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  downloadJournalEntryExcel(payload: any): Observable<Blob> {
    return this.httpClient.post(
      `${this.baseApiUrl}reports/downloadjournalentryexcel`,
      payload,
      {
        responseType: 'blob'
      }
    ).pipe(
      timeout(600000) 
    );
  }

}

